import React from 'react';

export const CHECKOUT_STEPS = {
  CONTACT_INFORMATION: 1,
  UNIT_INFORMATION: 2,
  PAYMENT: 3,
  COMPLETE: 4,
};

const CurrentStepContext = React.createContext(CHECKOUT_STEPS.CONTACT_INFORMATION);

CurrentStepContext.displayName = 'CurrentStepContext';

export default CurrentStepContext;
